import React, { useCallback, useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import PlayerRow from "../../Counter/components/PlayerRowTransfer";
import BalanceField from "../../Counter/components/BalanceField";
import TransferDialog from './TransferDialog';
import config from '../../../../config/config';
import parameters from '../../../../config/parameters';
import { requestAgentTransactionHistory } from '../../../../store/actionCreators/grantCredit';
import { requestCurrentClubMembers } from '../../../../store/actionCreators/club';
import {
  getAccountAvatars,
  getCurrentClubApprovedMembers,
  getCurrentAgentTransactions,
  getClubChipBalance,
  getCurrentClubAdminAccount,
} from "../../../../store/selectors";
import '../../../../assets/stylesheets/ClubSlide/GrantCredit.scss';

const transformData = (clubId, t) => ({
  applierName: t.source.nickname || t.source.username,
  applierId: t.source._id,
  playerName: t.destination.nickname || t.destination.username,
  playerId: t.source._id,
  direction: clubId === t.source._id ? 'sent' : 'claimedBack',
  currency: 'chip',
  date: moment(t.dateCreated).format('MM.DD.YY HH:mm'),
  amount: t.amount,
});

const renderTransaction = (clubId, agentId, selectedAgent, avatarList) => t => (
  <PlayerRow
    key={t.transactionId}
    player={transformData(clubId, t)}
    type="grantCredit"
    avatar={avatarList[selectedAgent.parentId === t.source._id ? selectedAgent._id : t.source._id]}
    role={parameters.accountTypeIds[selectedAgent && t.source._id === selectedAgent.roleAccountId ? selectedAgent.typeId : 1]}
  />
);

const GrantCredit = ({ isHistory }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { memberId, id } = useParams();
  const adminAccount = useSelector(getCurrentClubAdminAccount);
  const agentId = parseInt(memberId, 10) || adminAccount.clubAccountId;
  const clubId = parseInt(id, 10);
  const [transferDialog, setTransferDialog] = useState(null);

  const memberList = useSelector(getCurrentClubApprovedMembers);
  const selectedAgent = useMemo(
    () => memberList.find(m => m._id === agentId),
    [memberList, agentId]
  );
  const agentBalance = selectedAgent.roleAccountWallets &&
    selectedAgent.roleAccountWallets[0].balance;
  const avatarList = useSelector(getAccountAvatars) || {};
  const clubBalance = useSelector(getClubChipBalance);
  const transactions = useSelector(getCurrentAgentTransactions);
  const onSendOut = useCallback(() => setTransferDialog('sendOut'), []);
  const onClaimBack = useCallback(() => setTransferDialog('claimBack'), []);
  const onClose = useCallback(() => {
    setTransferDialog(null);
    dispatch(requestCurrentClubMembers());
  }, []);

  useEffect(() => {
    if (selectedAgent) {
      dispatch(requestAgentTransactionHistory(selectedAgent.roleAccountId));
    } else {
      dispatch(requestAgentTransactionHistory());
    }
  }, [selectedAgent]);

  return (
    <React.Fragment>
      {!isHistory &&
        <div className="grantCredit">
          <div className="grant-credit__balance-container">
            <div className="grant-credit__balance-container__club-balance">
              <span className="grant-credit__balance-text">
                {t('clubBalance')}:
              </span>
              <div className="chipBalance">
                <BalanceField
                  role='chip'
                  amount={clubBalance}
                />
              </div>
            </div>
            <div className="grant-credit__balance-container__agent-balance">
              <span className="grant-credit__balance-text">
                {`${t('agencyBalance')}:`}
              </span>
              <div className="chipBalance">
                <BalanceField
                  role='chip'
                  amount={agentBalance}
                />
              </div>
            </div>
          </div>
          {/* <span>{t.grantCreditText}</span> */}
        </div>
      }
      <div className="memberList grant-credit__member-list">
        {transactions.map(renderTransaction(clubId, agentId, selectedAgent, avatarList))}
      </div>
      {!isHistory &&
        <div className="dialogConfirmBox">
          <button className="secondary" onClick={onSendOut}>
            {t('button.sendOut')}
          </button>
          <button className="primary" onClick={onClaimBack}>
            {t('button.claimBack')}
          </button>
        </div>
      }
      {transferDialog && (<TransferDialog
        type={transferDialog}
        agent={selectedAgent}
        onClose={onClose}
      />)}
    </React.Fragment>
  );
};

export default GrantCredit;
